<div class="policy-page">
  <div class="policy-container">
    <h1>Contact</h1>
    <p>
      <a [href]="'mailto:' + supportEmail"><strong>{{ supportEmail }}</strong></a>
    </p>
  </div>
</div>
